import { render } from "./WorkbookRun.vue?vue&type=template&id=06d56321&scoped=true"
import script from "./WorkbookRun.vue?vue&type=script&lang=js"
export * from "./WorkbookRun.vue?vue&type=script&lang=js"

import "./WorkbookRun.vue?vue&type=style&index=0&id=06d56321&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-06d56321"

export default script